import image from "../IMAGES/R&R-09.png";
class blogPage {
  _blog = JSON.parse(localStorage.getItem("blogData"));
  _main = document.querySelector("main");
  _form = document.querySelector("#form");
  _post = document.querySelector("#post");
  _blogText = document.querySelector(".blogText");
  _comment = document.querySelector(".comments");
  _err = document.querySelector(".err");

  uploadComment(handler) {
    this._form?.addEventListener("click", function (e) {
      e.preventDefault();
      const blog = JSON.parse(localStorage.getItem("blogData"));

      const target = e.target.closest("#post");

      if (!target) return;
      const data = new FormData(form);
      const values = [...data.entries()];

      const info = {
        [values[0][0]]: values[0][1],
        [values[1][0]]: values[1][1],
        [values[2][0]]: values[2][1],
        uid: blog.uid,
      };
      // console.log(info);
      handler(info);
    });
  }

  _renderBlog(blog) {
    let options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const date = new Intl.DateTimeFormat("en-US", options).format(
      this._blog.time
    );

    console.log(this._blog.text.split("\n", 500).join(" <br>"));

    const text = this._blog.text.split("\n", 500).join(" <br>");
    const html = `

  

  <section
  class="blogpage flex items-center justify-center flex-col w-8/12 mx-auto p-10 sm:w-full 2sm:w-full md:w-11/12 lg:w-9/12 xl:w-9/12"
>
  <h1
    class="mb-4 text-2xl font-[600] text-center sm:text-base 2sm:text-lg md:text-xl"
  >
  ${this._blog.title}
  </h1>
  <p class="text-base sm:text-sm md:text-base">${date}</p>
  <section class=" 2xl:w-10/12 sm:w-full 2sm:w-11/12 md:w-11/12 ">
    <img
      class="rounded-lg w-full h-full mb-6 mt-6"
      src="${this._blog.url}"
      alt=""
    />
  </section>
  <p class="text-base sm:text-xs 2sm:text-sm">
  ${text}
  </p>
</section>

  <hr />

  

    `;
    this._main.insertAdjacentHTML("afterbegin", html);
  }

  _renderComments(data, time) {
    const html = `
   

<div class="flex space-x-4 mb-6">
<div class="rounded-full h-12 w-12">
  <img src="${image}" alt="" />
</div>
<div class="flex-1 space-y-6 py-1">
  <div class="">
    <div class="flex items-center justify-center">
      <div class="h-fit w-full flex rounded">
        <h1 class="pr-6 font-bold">${data.name}</h1>
        <h6 class="text-sm sm:text-xs">${time}</h6>
      </div>
    </div>
    <div class="h-fit w-full text-sm sm:text-xs break-all rounded">
    ${data.comment}
    </div>
  </div>
</div>
</div>
    `;

    const checked =
      data !== "" ? html : ` <p class="err text-center">No Comments Yet...</p>`;

    this?._comment?.insertAdjacentHTML("afterbegin", checked);
    if (data !== "") document.querySelector(".err").style.display = "none";
  }
}

export default new blogPage();
